import { PosSessionsFacade } from '@adminStore/pos-sessions';
import * as PosSessionsActions from '@adminStore/pos-sessions/pos-sessions.actions';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ClosePosSessionDto } from '@klubovna/api-client';
import { Actions, ofType } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { CloseSessionDialogData } from '@posModels';
import { SharedModule } from '@shared';

@Component({
  selector: 'app-close-session-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './close-session-dialog.component.html',
  styleUrl: './close-session-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseSessionDialogComponent {
  private dialogRef = inject(MatDialogRef<CloseSessionDialogComponent>);
  private data = inject<CloseSessionDialogData>(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);
  private posSessionsFacade = inject(PosSessionsFacade);
  private actions$ = inject(Actions);

  sessionName = signal<string | undefined>(this.data?.sessionName);
  closing = signal(false);

  closeForm: FormGroup = this.fb.group({
    closingCashCents: [ null, [ Validators.min(0) ] ],
  });

  constructor() {
    this.actions$.pipe(
      ofType(PosSessionsActions.closeSessionSuccess),
      takeUntilDestroyed(),
    ).subscribe(() => this.dialogRef.close());

    this.actions$.pipe(
      ofType(PosSessionsActions.closeSessionFailure),
      takeUntilDestroyed(),
    ).subscribe(() => this.closing.set(false));
  }

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    const formValue = this.closeForm.value;
    const closingCashCents = formValue.closingCashCents !== null && formValue.closingCashCents !== undefined
      ? Math.round(formValue.closingCashCents * 100)
      : undefined;

    const body: ClosePosSessionDto = closingCashCents !== undefined ? { closingCashCents } : {};

    this.closing.set(true);
    this.posSessionsFacade.closeSession(this.data.sessionId, body);
  }
}

